module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('article', {
    attrs: {
      "epub:type": "chapter"
    }
  }, [_c('div', {
    staticClass: "bodymatter",
    attrs: {
      "epub:type": "bodymatter"
    }
  }, [_c('section', {
    attrs: {
      "epub:type": "division",
      "id": "c02"
    }
  }, [_c('div', {
    staticClass: "chbrd"
  }, [_c('h1', {
    staticClass: "chapter_date"
  }, [_c('a', {
    attrs: {
      "id": "page14"
    }
  }), _c('strong', [_vm._v("c. 585 BCE")])]), _vm._v(" "), _c('h1', {
    staticClass: "chapter_title"
  }, [_vm._v("Birth of Western Philosophy")]), _vm._v(" "), _c('p', {
    staticClass: "bauthorb"
  }, [_c('strong', [_vm._v("Thales")]), _vm._v(" (c. 625–c. 545 BCE), "), _c('strong', [_vm._v("Anaximander")]), _vm._v(" (c. 610–c. 546 BCE), "), _c('strong', [_vm._v("Anaximenes")]), _vm._v(" (fl. c. 545 BCE)")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_vm._v("Socrates said that “philosophy begins in wonder.” In Western civilization, philosophy began when a group of Greek sages in the Aegean seaport of Miletus sought to satisfy their sense of wonder by asking new kinds of questions. Instead of relying on mythology and supernatural forces to explain nature, these thinkers began to use reason and observation. This marked the beginning of science as well as philosophy.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Thales has traditionally been regarded as the first Western philosopher. He was one of the Seven Wise Men of Greece and was reputed to have studied in Egypt, where he learned geometry. Some early sources claimed he successfully predicted eclipses. One anecdote relates how Thales was mocked by a servant girl for falling into a well while stargazing; perhaps to demonstrate that he was no absentminded professor, it is also said he was the first to show that there are 365 days in a year.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Thales asked whether there is some basic “stuff” out of which everything is made, and concluded that there is. Everything is made of water, he claimed. Why he believed this is unclear. Perhaps he was impressed by the fact that water can be a solid, a liquid, or a gas. Aristotle speculates that Thales was struck by the linkage between water and life, noting that seeds, for example, always contain moisture. Whatever the reasons, what is important is the kind of explanation Thales was looking for. Here, for the first time in recorded history, someone was trying to explain the natural world entirely in terms of natural phenomena.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Thales inspired others to seek similar explanations. His follower, Anaximander, suggested that the fundamental stuff is not water, but an indeterminate substance he called the "), _c('em', [_vm._v("apeiron,")]), _vm._v(" Greek for “boundless” or “indefinite.” Not long after Anaximander, another philosopher from Miletus named Anaximenes—apparently impressed by the fact that air can become more or less dense—speculated that everything is some form of air. From such seemingly unpromising beginnings, the Western philosophical quest began.")]), _vm._v(" "), _c('p', {
    staticClass: "captionl",
    attrs: {
      "id": "img15"
    }
  }, [_c('em', [_vm._v("A nineteenth-century engraving of Thales of Miletus, considered by many to be the first Western philosopher.")])]), _vm._v(" "), _c('div', {
    staticClass: "dis_imgb"
  }, [_c('a', {
    attrs: {
      "id": "page15"
    }
  }), _c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/15-1.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "xref"
  }, [_c('p', {
    staticClass: "seal"
  }, [_c('span', {
    staticClass: "sls"
  }, [_c('strong', [_vm._v("SEE ALSO")])]), _vm._v(" "), _c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9781454935575_c06"
    }
  }, [_vm._v("Anthropomorphization (c. 530 BCE)")]), _vm._v(", "), _c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9781454935575_c21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Atoms and the Void (c. 420 BCE)")])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2be11378","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/9781454935575_c02.vue
// module id = 78
// module chunks = 0